import { faqResource } from './resource'

export const faqService = {
  getFaq: (signal) => () => faqResource.get('/api/faq', { signal: signal() })
}
